module.exports = __webpack_public_path__ + "img/wrong-person.4b007b49.png";